import React, { useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import Orange_White_Border_Btn from "../../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import "./Close_Trade_Modal.css";
import Successfull_Modal from "../successfull_modal/Successfull_Modal";
import Success_Lottie from "../../../animation/success_lottie/Success_Lottie";
import Close_modal from "../close_modal/Close_modal";

const Close_Trade_Modal = (props) => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [modalCloseShow, setModalCloseShow] = useState(false);
  const [error, setError] = useState("");
  const [closeQuantity, setCloseQuantity] = useState("");

  const handleSubmit = () => {
    if (!closeQuantity) {
      setError("Please enter quantity");
      return;
    }

    if (Number(closeQuantity) > Number(props?.quantity)) {
      setError("Quantity cannot be greater than available quantity");
      return;
    }

    if (Number(closeQuantity) <= 0) {
      setError("Quantity must be greater than 0");
      return;
    }

    setError("");
    setModalCloseShow(true);
  };

  return (
    <section className="Close_Trade_Modal">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Close_Trade_Modal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>Close Trade</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="note_div">
            <p className="note">Available Quantity : {props?.quantity}</p>
          </div>

          <div className="upload_div">
            <Form.Label>No Of Quantity</Form.Label>
            <InputGroup className="upload_input_group mb-3">
              <Form.Control
                type="number"
                placeholder="Enter quantity"
                value={closeQuantity}
                min="1"
                className="file_input"
                onChange={(e) => {
                  setCloseQuantity(e.target.value);
                  setError("");
                }}
              />
            </InputGroup>

            {error && <p className="text-danger">{error}</p>}
          </div>

          <div className="btn_holder">
            <Orange_White_Border_Btn btn_name="Submit" onClick={handleSubmit} />
          </div>
        </Modal.Body>
      </Modal>

      <Successfull_Modal
        message="Profile Doc Send For Verification Successfully"
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        lottie={<Success_Lottie />}
      />

      <Close_modal
        getGraphData={props.getGraphData}
        show={modalCloseShow}
        closeTradeId={props?.closeTradeId}
        amount={props?.amount}
        closeQuantity={closeQuantity}
        onHide={() => setModalCloseShow(false)}
        onClose={() => props?.onHide(false)}
        latestAmount={props?.latestAmount}
      />
    </section>
  );
};

export default Close_Trade_Modal;
